import React from "react";

const Contact: React.FC = () => {
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "40px 20px",
        lineHeight: "1.6",
      }}
    >
      <h1 style={{ color: "#333", marginBottom: "2rem" }}>Contact Us</h1>

      <div style={{ marginBottom: "3rem" }}>
        <h2>Get in Touch</h2>
        <p>
          We'd love to hear from you. Please feel free to reach out to us using
          any of the methods below.
        </p>
      </div>

      <div style={{ marginBottom: "3rem" }}>
        <h2>Contact Information</h2>
        <p>
          <strong>Email:</strong> info@example.com
        </p>
        <p>
          <strong>Phone:</strong> +1 (555) 123-4567
        </p>
        <p>
          <strong>Address:</strong> 123 Business Street, City, State 12345
        </p>
        <p>
          <strong>Business Hours:</strong> Monday - Friday, 9:00 AM - 5:00 PM
          EST
        </p>
      </div>

      <div style={{ marginBottom: "3rem" }}>
        <h2>Send us a Message</h2>
        <form style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <div>
            <label
              htmlFor="name"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              Name:
            </label>
            <input
              type="text"
              id="name"
              name="name"
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid #ddd",
                borderRadius: "4px",
                fontSize: "1rem",
              }}
              placeholder="Your name"
            />
          </div>

          <div>
            <label
              htmlFor="email"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              Email:
            </label>
            <input
              type="email"
              id="email"
              name="email"
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid #ddd",
                borderRadius: "4px",
                fontSize: "1rem",
              }}
              placeholder="your.email@example.com"
            />
          </div>

          <div>
            <label
              htmlFor="message"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              Message:
            </label>
            <textarea
              id="message"
              name="message"
              rows={5}
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid #ddd",
                borderRadius: "4px",
                fontSize: "1rem",
                resize: "vertical",
              }}
              placeholder="Your message here..."
            />
          </div>

          <button
            type="submit"
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "0.75rem 1.5rem",
              border: "none",
              borderRadius: "4px",
              fontSize: "1rem",
              cursor: "pointer",
              alignSelf: "flex-start",
            }}
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
